import { getDisplayLevel } from '@pokerroom/types';

interface BlindLevel {
  levelNo: number;
  isBreak: boolean;
  smallBlind?: number;
  bigBlind?: number;
  ante?: number;
  bba?: number;
}

export function nextPlayableLevel(levels: BlindLevel[], nextLevelNo: number) {
  const next = levels.find((level) => level.levelNo >= nextLevelNo && !level.isBreak);
  return next ? { ...next, displayLevel: getDisplayLevel(levels, next.levelNo) } : null;
}
